import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router";

const BackLink = ({
  text = "Back",
  redirectUrl = null,
  replace = false,
  className = "",
  depth = -1,
}) => {
  const navigate = useNavigate();

  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();

        if (redirectUrl) {
          navigate(redirectUrl, { replace });
        } else {
          navigate(depth);
          return;
        }
      }}
      className={`opacity-66 hover:text-primary hover:opacity-100 mb-4 inline-flex items-center ${className}`}
    >
      <ArrowLeft className="w-4 h-4 mr-2" /> {text}
    </a>
  );
};

export default BackLink;
